import { PERMISSIONS } from "@lib/permissions/permissions.generated";
import { createFileRoute, Outlet } from "@tanstack/react-router";

export const Route = createFileRoute("/_app/rh/contrats")({
  staticData: {
    permission: PERMISSIONS.RH.CONTRATS.VIEW,
  },
  component: () => <Outlet />,
});
